const TITLE = '(?:mr|mrs|ms|miss|mx|dr|prof|rev|lord|lady|sir)';
const SEPARATOR = '(?:[.&+/]|(?<!,),|and)';

const TITLE_WORD = new RegExp(
  `^${TITLE}(?:${SEPARATOR}|(?<=[&+/.]|and)(?:${TITLE}|s))*$`
);
const JOINER_WORD = /^(?:&|and|\+|\/)$/;

const DOTTED_INITIALS = /^[a-z](?:\.[a-z])*\.?$/i;
const ALL_CAPS_INITIALS = /^\p{Lu}{1,3}$/u;
const HAS_LETTER = /\p{L}/u;

const isTitleWordOrJoiner = (word: string) =>
  TITLE_WORD.test(word.toLowerCase()) || JOINER_WORD.test(word.toLowerCase());

const isNotAFirstName = (word: string) =>
  !HAS_LETTER.test(word) ||
  DOTTED_INITIALS.test(word) ||
  ALL_CAPS_INITIALS.test(word);

export const getContactFirstName = (name: string | null | undefined) => {
  const words = (name ?? '')
    .replace(/&(?:amp;)+/gi, '&')
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  const numLeadingTitleWords = words.findIndex(
    (word) => !isTitleWordOrJoiner(word)
  );

  const rest = words.slice(numLeadingTitleWords);
  const firstAfterTitle = rest[0] ?? '';
  if (
    // Only 1 name after the title, so assume it's the surname.
    rest.length <= 1 ||
    // The first word doesn't look like a first name (e.g. initials).
    isNotAFirstName(firstAfterTitle) ||
    // A title later in the name - usually compound (e.g. "Mr Smith & Mrs Jones").
    rest.slice(0, -1).some(isTitleWordOrJoiner) ||
    // All words are titles (e.g. "Miss Lord")
    numLeadingTitleWords === -1
  ) {
    return words.join(' ');
  }
  return firstAfterTitle;
};
